export const FONT_TITLE = "/fonts/Orbitron/Orbitron-VariableFont_wght.ttf";
export const FONT_DESCRIPTION = "/fonts/Rajdhani/Rajdhani-Regular.ttf";
export const FONT_DESCRIPTION_BOLD = "/fonts/Rajdhani/Rajdhani-Bold.ttf";
